// Folds text for accent- and case-insensitive matching ("Muñoz" matches
// "munoz"). For comparisons only; never store or send the folded value.
export const normTxt = (s) =>
  (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
